import { TagRecordCategoryEnum } from '../enums/tag-record-category.enum';

/**
 * Create tag DTO
 */
export class CreateTagDto {
  color?: string | null;
  name!: string;
  notes?: string | null;
  recordCategory!: TagRecordCategoryEnum;
  description?: string | null;
}
